import React, { useEffect, useRef, useState } from "react";
import { TagIcon } from "@heroicons/react/24/solid";

const styles = {
  container: {
    base: "flex gap-1",
    regular: "mt-2",
  },
  icon: {
    base: "text-gray-400 flex-shrink-0",
    regular: "size-5",
    compact: "size-4",
  },
  wrapper: {
    base: "flex gap-1",
    regular: "flex-row gap-2 flex-wrap",
    compact: "flex-wrap",
  },
  tag: {
    base: "bg-gray-200 font-bold text-gray-500 text-xs rounded-lg whitespace-nowrap",
    regular: "p-1 text-center",
    compact: "px-2 py-1",
  },
};

export function TagList({ tags, compact = false, iconPosition = "left" }) {
  const [isMultiLine, setIsMultiLine] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const checkMultiLine = () => {
      if (!wrapperRef.current) return;

      const wrapper = wrapperRef.current;

      requestAnimationFrame(() => {
        const styles = getComputedStyle(wrapper);
        const lineHeight = parseInt(styles.lineHeight);
        const actualHeight = wrapper.offsetHeight;

        setIsMultiLine(actualHeight > lineHeight * 1.2);
      });
    };

    checkMultiLine();

    const resizeObserver = new ResizeObserver(() => {
      checkMultiLine();
    });

    if (wrapperRef.current) {
      resizeObserver.observe(wrapperRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [tags]);

  if (!tags?.length) return null;

  const variant = compact ? "compact" : "regular";
  const icon = (
    <TagIcon className={`${styles.icon.base} ${styles.icon[variant]}`} />
  );

  const alignmentClass = isMultiLine ? "items-start" : "items-center";

  return (
    <div
      className={`${styles.container.base} ${alignmentClass} ${!compact && styles.container.regular}`}
    >
      {iconPosition === "left" && icon}
      <div
        ref={wrapperRef}
        className={`${styles.wrapper.base} ${styles.wrapper[variant]}`}
      >
        {tags.map((tag) => (
          <span
            key={tag.id}
            className={`${styles.tag.base} ${styles.tag[variant]}`}
          >
            {tag.title}
          </span>
        ))}
      </div>
      {iconPosition === "right" && icon}
    </div>
  );
}
